import { trigger, style, transition, animate } from '@angular/animations';

export const SharedAnimations = {
    inOutAnimetion: trigger(
        'inOutAnimation',
        [
            transition(
                ':enter',
                [
                    style({ right: '-60%' }),
                    animate('0.35s ease', style({ right: 0 }))
                ]
            ),
            transition(
                ':leave',
                [
                    style({ right: 0}),
                    animate('0.35s ease', style({ right: '-60%' }))
                ]
            )
        ]
    )
}